import React from 'react';
import './style.css'
import { useNavigate } from 'react-router-dom';

const cardStyle = {
  height: '200px',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: "pointer"
};

const imageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '50%',
};

const titleStyle = {
  fontSize: 'clamp(18px, 2vw, 22px)',
  marginTop: "10px",
  fontWeight: '600',
  whiteSpace: "nowrap"
};

export default function CategoriesCard({ isSelected, data, navigate_to, name = 'นาฬิกา', image, onClick }) {

  const navigate = useNavigate()


  return (
    <div onClick={() => onClick ? onClick(data) : navigate(navigate_to)} className={`categories-card-responsive`} style={cardStyle}>
      <div className="category-card-image-cotainer">
        <img
          src={image ?? ''}
          alt={name}
          style={imageStyle}
        />
      </div>
      <h3 style={titleStyle} className={`${isSelected ? "categories-card-selected" : "categories-card"}`}>{name}</h3>
    </div>
  );
}
